import { Link } from "@StarberryUtils";
import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import { Col, Row, Container } from 'react-bootstrap';
import DownloadPDF from "../DownloadPDF/DownloadPDF";
import ContactForm from "../ContactForm/ContactForm";
import {
  isMobileOnly
} from "react-device-detect";
import "./SliderCards.scss";
import ReactMarkdown from "react-markdown"

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.4 }
  }
}

const contentItem = {
  hidden: { opacity: 0, y: -40 },
  visible: (custom) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.6,
      ease: [0.33, 1, 0.68, 1],
    },
  })
}

// Trim function for Read More
const trimText = (text, limit = 120) => {
  if (!text) return "";
  if (text.length <= limit) return text;
  return text.substring(0, limit) + "...";
};

const SliderCards = (props) => {
  const [openDownloadForm, setOpenDownloadForm] = useState(false);
  const [openContactForm, setOpenContactForm] = useState(false);
  const [openDownloadLink, setOpenDownloadLink] = useState("");

  // Read More toggle states
  const [expanded, setExpanded] = useState({});

  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    autoplay: false,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
  };

  return (
    <>
      <section className="slider-cards">
        <Container>
          <Row>
            <Col md={12}>
              <div variants={titleVariants}>
                <ReactMarkdown
                  source={props.intro}
                  allowDangerousHtml
                  className="sec-title text-center text-md-left"
                />
              </div>
            </Col>
          </Row>

          <Row className="home-slide-news">
            <Col md={12}>
              <div variants={contentVariants}>
                <Slider className="study-slider" {...settings}>
                  {props.cards.map((card, i) => (
                    <div key={i} custom={i} variants={contentItem}>
                      <div className="started-details helpful">
                        <p className="title">{card.title}</p>

                        <div className="case-study-image-link">
                          <figure className="study-img">
                            <img
                              loading="lazy"
                              src={card.image?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
                              alt={`${card.title} - Martyn Gerrard`}
                            />
                          </figure>
                        </div>

                        {/* Read More content */}
                        <div className="card-text">
                          <p className="card-content">
                            {expanded[i]
                              ? card.content
                              : trimText(card.content, 120)
                            }
                          </p>


                          {/* Show Read More button only on desktop */}
                          {card.content.length > 100 && (
                            <button
                              className="read-more-btn"
                              onClick={() =>
                                setExpanded(prev => ({ ...prev, [i]: !prev[i] }))
                              }
                            >
                              {expanded[i] ? "Read Less" : "Read More"}
                            </button>
                          )}
                        </div>

                        {/* CTA */}
                        {card.cta_link &&
                          (card.cta_link.includes("download_") ||
                            card.cta_link.includes("contact_modal")) ? (
                          <button
                            className="btn w-100"
                            onClick={() => {
                              if (card.cta_link.includes("download_")) {
                                setOpenDownloadForm(true);
                                setOpenDownloadLink(card.cta_link);
                              } else {
                                setOpenContactForm(true);
                              }
                            }}
                          >
                            {card.cta_label}
                          </button>
                        ) : (
                          <Link to={`${card.cta_link}`}>
                            <strong className="btn d-block">{card.cta_label}</strong>
                          </Link>
                        )}
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Modals */}
        <DownloadPDF
          openForm={openDownloadForm}
          setOpenForm={setOpenDownloadForm}
          fileName={openDownloadLink}
        />
        <ContactForm
          openForm={openContactForm}
          setOpenForm={setOpenContactForm}
        />
      </section>
    </>
  );
}

export default SliderCards;
